<template>
  <div class="w-full">
    <div class="inline-flex items-center mb-3">
      <SymbolTradeStateIcon
        :trading-state-code="TRADING_STATE_CODES.preOpening"
        size="medium"
      />

      <NText
        variant="caption2"
        weight="bold"
        class="text-neutral-secondary mr-1"
      >
        {{ t('modules.watchlist.preOpeningSymbol') }}
      </NText>
    </div>

    <NLoading
      v-if="isLoadingPreOpeningWatchlistImage"
      class="mx-auto my-2 text-brand-primary"
      size="10"
    />

    <Image
      class="mx-auto"
      src="pre_opening_watchlist"
      alt="pre_opening_watchlist"
      @load="isLoadingPreOpeningWatchlistImage = false"
    />

    <NText
      variant="caption2"
      weight="medium"
      class="text-neutral-primary block pb-4 border-b border-neutral-secondary"
    >
      {{ t('modules.watchlist.preOpeningSymbolDescription') }}
    </NText>

    <div class="inline-flex items-center justify-around pt-6 relative mb-3">
      <SymbolTradeStateIcon
        :trading-state-code="TRADING_STATE_CODES.closed"
        size="medium"
      />
      <SymbolTradeStateIcon
        :trading-state-code="TRADING_STATE_CODES.open"
        class="-right-1.5 border border-neutral-primary"
        size="medium"
      />

      <NText
        variant="caption2"
        weight="bold"
        class="text-neutral-secondary -mr-0.5"
      >
        {{ t('modules.watchlist.outsidePreOpeningSymbol') }}
      </NText>
    </div>

    <NLoading
      v-if="isLoadingWatchlistImage"
      class="mx-auto my-2 text-brand-primary"
      size="10"
    />

    <Image
      class="mx-auto"
      src="watchlist"
      alt="watchlist"
      @load="isLoadingWatchlistImage = false"
    />

    <NText variant="caption2" weight="medium" class="text-neutral-primary">
      {{ t('modules.watchlist.outsidePreOpeningSymbolDescription') }}
    </NText>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { TRADING_STATE_CODES } from '@core/symbol';

import { SymbolTradeStateIcon } from '@/modules/symbol';

import Image from '@/components/Image.vue';

const { t } = useI18n();

const isLoadingWatchlistImage = ref(true);
const isLoadingPreOpeningWatchlistImage = ref(true);
</script>
